import axios from '@octagon/axios';

// Define the authentication headers for the API instance
const authHeaders = {
  "Content-Type": "application/json",
  'Access-Control-Allow-Origin': '*',
  'X-Requested-With' : 'XMLHttpRequest',
  'Accept' : "application/json"
}

// Define the default headers for the API instance (without Authorization)
const mainHeaders = {
  "Content-Type": "application/json",
  'Access-Control-Allow-Origin': '*',
  'X-Requested-With' : 'XMLHttpRequest',
  'Accept' : "application/json"
}

// Define the default headers for the file download API instance (without Authorization)
const fileDownloadHeaders = {
  'Access-Control-Allow-Origin': '*',
  'X-Requested-With' : 'XMLHttpRequest',
  'Accept' : "application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
}

const url = new URL(window.location.href);
const baseUrl = url.hostname.startsWith('localhost')
  ? '' // Use relative URLs on localhost so requests go through webpack dev server proxy
  : `${url.protocol}//${url.host}`;

// Create the authentication API instance with the default headers
const apiInstanceAuth = axios.create({
  baseURL: baseUrl + "/auth",
  headers: authHeaders,
  withCredentials: false
});

// Create the API instance with the default headers
const apiInstance = axios.create({
  baseURL: baseUrl + "/api",
  headers: mainHeaders,
  withCredentials: false
});

// Create the file download API instance with the default headers
const fileDownloadApiInstance = axios.create({
  baseURL: baseUrl + "/api",
  headers: fileDownloadHeaders,
  withCredentials: false
})

// Interceptors to inject the latest token before each request
function getToken() {
  return sessionStorage.getItem('encompassToken');
}

function authInterceptor(config: any) {
  const token = getToken();
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  } else {
    delete config.headers['Authorization'];
  }
  return config;
}

// For main API instance
apiInstance.interceptors.request.use(authInterceptor);

// For file download API instance
fileDownloadApiInstance.interceptors.request.use(authInterceptor);

// Temporary: detect internal user access restriction during DynamoDB issue. Remove when resolved.
function internalAccessRestrictedInterceptor(error: any) {
  if (error?.response?.status === 403 &&
      error?.response?.data?.message === 'INTERNAL_ACCESS_RESTRICTED') {
    window.dispatchEvent(new CustomEvent('internalAccessRestricted', {
      detail: { message: 'INTERNAL_ACCESS_RESTRICTED' }
    }));
  }
  return Promise.reject(error);
}
apiInstance.interceptors.response.use((response) => response, internalAccessRestrictedInterceptor);
fileDownloadApiInstance.interceptors.response.use((response) => response, internalAccessRestrictedInterceptor);

// Export the API instances
export { apiInstanceAuth, apiInstance, fileDownloadApiInstance, mainHeaders, fileDownloadHeaders };
